export default __webpack_public_path__ + "static/media/ellipsis-h-grey.8eebbba8.svg";